export const ContactUsStyle = theme => ({
	paper: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		padding: "2em"
	},
	container: {
		display: "flex",
		flexWrap: "wrap"
	},
	avatar: {
		margin: theme.spacing.unit,
		backgroundColor: theme.palette.secondary.main
	},
	root: {
		marginTop: 16,
		display: "flex",
		width: "100%",
		flexWrap: "wrap"
	},
	wrapper: {
		position: "relative",
		width: "100%"
	},
	buttonProgress: {
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12
	},
	submit: {
		marginTop: theme.spacing.unit * 2
	},
	summitButt: {
		backgroundColor: "#8252fa",
		color: "#ffffff !important"
	},
	disableButt: {
		backgroundColor: "#e8e5eb",
		color: "#ffffff !important"
	}
})
